<template>
  <div class="tcgaExpAll">
    <div id="umapRegularGene" style="height: 500px"></div>
  </div>
</template>

<script>
import axios from "axios";
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";
import exporting from "highcharts/modules/exporting";

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
exporting(Highcharts);

export default {
  mounted() {
    //开始绘图
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/publications_umapgene.php",
        {
          params: {
            datasetId: this.$route.query.datasetId,
          },
        }
      )
      .then((response) => {
        this.moreChart(response.data);
        console.log(response.data);
      });
  },
  methods: {
    moreChart(data) {
      if (this.chart) {
        this.chart.destroy();
      }
      // 初始化 Highcharts 图表
      this.chart = new Highcharts.chart("umapRegularGene", {
        credits: {
          enabled: false,
        },
        chart: {
          type: "scatter",
          zoomType: "xy",
        },
        title: {
          text: "",
        },
        legend: {
          align: "right", // Right align
          verticalAlign: "middle", // Center vertically
          layout: "vertical", // Arrange vertically
        },
        xAxis: {
          title: {
            enabled: true,
            text: "UMAP_1",
          },
          startOnTick: true,
          endOnTick: true,
          showLastLabel: true,
          lineWidth: 0, // 设置X轴线宽度为2
          lineColor: "black", // 设置X轴线颜色为黑色
          crosshair: true, // 可以添加十字准线突出当前选中点
          // 强调x=0轴，如果x轴不总是在y=0
          plotLines: [
            {
              color: "black", // 红色标线
              width: 1.3, // 线宽为2
              value: 0, // 定位在x = 0
            },
          ],
        },
        yAxis: {
          title: {
            text: "UMAP_2",
          },
          lineWidth: 0, // 设置Y轴线宽度为2
          lineColor: "black", // 设置Y轴线颜色为黑色
          crosshair: true, // 可以添加十字准线突出当前选中点
          // 强调y=0轴
          plotLines: [
            {
              color: "black", // 红色标线
              width: 1.8, // 线宽为2
              value: 0, // 定位在y = 0
            },
          ],
        },
        tooltip: {
          useHTML: true,
          style: {
            pointerEvents: "auto",
          },
          headerFormat: "<b>Perturbed gene :{series.name}</b><br>",
          pointFormat: "<b>Cell ID: </b> {point.cellname}",
        },
        plotOptions: {
          series: {
            cursor: "pointer",
            marker: {
              symbol: "circle", // 设置点为圆形
            },
            // point: {
            //   events: {
            //     click: function () {
            //       if (this.pname && this.pname.startsWith("PC")) {
            //         window.open(
            //           "http://research.gzsys.org.cn/perturbdb/#/pcDetails?pcID=" +
            //             this.pname,
            //           "_blank"
            //         );
            //       }
            //     },
            //   },
            // },
          },
          scatter: {
            marker: {
              radius: 2.0,
              fillOpacity: 0.8,
              states: {
                hover: {
                  enabled: true,
                  lineColor: "rgb(100,100,100)",
                },
              },
            },
            states: {
              hover: {
                marker: {
                  enabled: true,
                },
              },
            },
          },
        },
        series: data,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit css to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
